import { Title } from '@portal_components/components/Title';
import type { ReactElement } from 'react';

export interface props {
  title: string;
  children: ReactElement[] | ReactElement;
}

export const Modal = (props: props) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-solid-deep-blue opacity-70"></div>
      <div className={`relative z-10 p-6 sm:p-10 w-full max-w-lg max-h-[90vh] bg-elevation-1`}>
        <Title text={props.title} className="mb-3 font-bold" />
        {props.children}
      </div>
    </div>
  );
};

export const FormModal = (props: props) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-solid-deep-blue opacity-70"></div>
      <div className={`relative z-10 p-6 sm:p-10 bg-elevation-1 w-full max-w-[50%] max-h-[90vh] overflow-auto border-y-2 border-interactive-coral`}>
        <Title text={props.title} className="mb-3 font-bold" />
        {props.children}
      </div>
    </div>
  );
};
